let NAME_TITLE_MAP = {
  'Automation to create patient in IDS': 'Create patient',
  'Archive IDS patients': 'Archive patients',
  'Virtual Care case ready for review': 'Virtual Care',
}

export function getTitle(name) {
  return NAME_TITLE_MAP[name] || name
}
